"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsUserListTable = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const CheckBox_1 = require("../../CheckBox");
const Field_1 = require("../../Form/Field");
const legacy_1 = require("../../Form/Field/Select/legacy");
const Icon_1 = require("../../Icon");
const LoadingOverlay_1 = require("../../LoadingOverlay");
const Table_1 = require("../../Table");
const messages_1 = require("./messages");
const utils_1 = require("./utils");
require("./index.scss");
const className = 'permissions-user-list';
const userTypes = [
    'all',
    'customer',
    'manager',
    'agent',
];
const PermissionsUserListTable = (props) => {
    const { isLoading, isDirty, tableColumns, tableData, submitForm, searchText, isActiveOnly, userType, } = props;
    const intl = (0, react_intl_1.useIntl)();
    const handleSubmitForm = (event) => {
        event.preventDefault();
        submitForm({
            searchText,
            isActiveOnly,
            userType,
        });
    };
    const handleSearchTextChange = (event) => {
        const { value } = event.target;
        submitForm({
            searchText: value,
            isActiveOnly,
            userType,
        });
    };
    const handleIsOnlyActiveChange = () => {
        submitForm({
            searchText,
            isActiveOnly: !isActiveOnly,
            userType,
        });
    };
    const handleUserTypeChange = (event) => {
        const value = event.target.value;
        submitForm({
            searchText,
            isActiveOnly,
            userType: value,
        });
    };
    const loadingOverlayProps = {
        isLoading: isLoading || isDirty,
        hideLoader: !isLoading,
        loadingMessage: isLoading ? undefined : '',
        modificators: 'top',
    };
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("form", { className: `${className}__form`, onSubmit: handleSubmitForm },
            react_1.default.createElement("div", { className: `${className}__icon` },
                react_1.default.createElement(Icon_1.Icon, { name: 'search' })),
            react_1.default.createElement("div", { className: `${className}__search` },
                react_1.default.createElement(Field_1.FormField, { modificators: 'search', placeholder: intl.formatMessage(messages_1.messages.searchPlaceholder), onChange: handleSearchTextChange, value: searchText })),
            react_1.default.createElement("div", { className: `${className}__buttons` }),
            react_1.default.createElement("div", { className: `${className}__checkboxes` },
                react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/UserPermissions/List:IsActiveOnly', defaultMessage: 'Active only' }), modificators: 'inline', onChange: handleIsOnlyActiveChange, checked: isActiveOnly || false })),
            react_1.default.createElement("div", { className: `${className}__select` },
                react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/UserPermissions/List:userType', defaultMessage: 'User Type' }), items: userTypes, value: userType, onChange: handleUserTypeChange }))),
        react_1.default.createElement("div", { className: `${className}__list` },
            react_1.default.createElement(LoadingOverlay_1.LoadingOverlay, { ...loadingOverlayProps },
                react_1.default.createElement(Table_1.Table, { columns: tableColumns, data: tableData, manualSortBy: true, tableModificators: utils_1.tableModificators })))));
};
exports.PermissionsUserListTable = PermissionsUserListTable;
//# sourceMappingURL=index.js.map